import $ from "jquery";

/*------------------------------------*\
    FORM SAVE
\*------------------------------------*/
class FormSave {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        
        let saveButton = self.elem.querySelector('[data-save-button]');
        let saveButtonBack = self.elem.querySelector('[data-save-button-back]');
        let formAction = self.elem.getAttribute('action');

        self.checkLocalStorageAvailable();
        self.populateFields();

        // Listen for click event on form save button
        saveButton.addEventListener('click', evt => {
            // Call the saveData() method
            self.saveData();

            // If form is valid...
            if (self.elem.checkValidity()) {
                // Continue to next page
                window.location = formAction;
            }
        });

        if (saveButtonBack) {
            saveButtonBack.addEventListener('click', evt => {
                // Call the saveData() method
                self.saveData();

                // If form is valid...
                if (self.elem.checkValidity()) {
                    // Continue to next page
                    window.location = formAction;
                }
            });
        }
    }

    populateFields() {
        let self = this;

        // Filter out any hidden fields (used for setting defaults for checkbox/radio fields) and loop through
        Array.from(self.elem.elements).filter(field => field.type !== 'hidden').forEach(field => {
            // Get the field's related value from local storage
            let storedValue = localStorage.getItem(field.name);

            // If a value exists in local storage...
            if (storedValue !== null) {
                // Parse the data we get from local storage
                let storedValueObj = JSON.parse(storedValue);

                // If the field is a checkbox or radio input...
                if (field.type === 'checkbox' || field.type === 'radio') {
                    // If the field's value matches what is stored in local storage...
                    if (field.value === storedValueObj.value) {
                        // Check the checkbox/radio
                        field.checked = true;
                    }
                    // Otherwise...
                    else {
                        // Uncheck the checkbox/radio
                        field.checked = false;
                    }
                }
                // If the fields is not a checkbox or radio input...
                else {
                    if (storedValueObj.value.length > 0) {
                        field.value = this.escapeValue(storedValueObj.value)
                    }
                }
            }
        });
    }
    saveData() {
        let self = this;

        // Loop through the form's fields
        Array.from(self.elem.elements).forEach(field => {

            // Check validity of form
            if(self.elem.checkValidity()) {
                // If the field is either:
                // a. a checkbox/radio input and it's checked, or
                // b. not a checkbox/radio input
                if ((field.type === 'radio' && field.checked) || (field.type !== 'checkbox' && field.type !== 'radio') || (field.name === '15-progress' && field.checked)) {
                    // Add the field's name, label and value to localStorage
                    // (JSON stringify the label and value)
                    localStorage.setItem(
                        field.name,
                        JSON.stringify({
                            'label': field.dataset.label,
                            'value': this.escapeValue(field.value)
                        })
                    );
                } else if((field.type === 'checkbox' && field.checked) && (field.name !== '15-progress')) {
                    const options = [];

                    // If field 'hidden to review'
                    if(field.name.includes('hidden')) {

                        // Push values to options array if checked
                        $('.multiple-checkbox').each(function () {
                            this.checked
                                ? options.push({
                                    "key": this.name,
                                    "label": this.dataset.label
                                })
                                : localStorage.removeItem(this.name);
                        });

                        // Set items into local storage
                        // (hidden from review but required
                        // for feedback persistance)
                        localStorage.setItem(
                            field.name,
                            JSON.stringify({
                                'label': field.dataset.label,
                                'value': this.escapeValue(field.value)
                            })
                        );
                    }

                    // Add the field's name, label and value to
                    // localStorage (JSON stringify the label and value)
                    localStorage.setItem(
                        field.name,
                        JSON.stringify({
                            'label': field.dataset.label,
                            'value': this.escapeValue(field.value)
                        })
                    );
                } else if(field.name === '15-progress' && !field.checked) {
                    // UGLY fix - remove stay informed checkbox from local storage if not checked
                    // If user changes mind this force removes local storage key
                    localStorage.removeItem('15-progress');
                }


                // Mark field's section as answered
                if(field.dataset.section && field.dataset.section !== '') {
                    localStorage.setItem(field.dataset.section, true);
                }
            }
        });

        localStorage.removeItem("");
    }

    checkLocalStorageAvailable() {
        let self = this;

        try {
            let test = window.localStorage;
        } catch(e) {
            let form = self.elem.querySelector('[data-feedback-form]')
            form.classList.add('d-none');
            
            let warning = document.querySelector('[data-storage-warning]');
            warning.classList.remove('d-none');
        }

    }
    escapeValue(value){
        return value ? value.replace(/</g,"&lt;").replace(/>/g, "&gt;") : value;
    }
}

export default FormSave;